'use client';
import { useEffect, useState } from 'react';

export const useCtaColor = (w2tChatColor?: string) => {
  const [ctaColor, setCtaColor] = useState<string>('');
  const [chatColor, setChatColor] = useState<string>('');
  const [hoverColor, setHoverColor] = useState<string>('');

  useEffect(() => {
    const computedStyles = window.getComputedStyle(document.documentElement);
    setCtaColor(
      computedStyles.getPropertyValue('--cta-color').trim() || '#2563eb'
    );

    const computedW2tcolor = w2tChatColor
      ? computedStyles.getPropertyValue(w2tChatColor).trim()
      : undefined;

    if (w2tChatColor && computedW2tcolor) setChatColor(computedW2tcolor);

    setHoverColor(
      computedStyles.getPropertyValue('--hover-color').trim() || '#507abc' //fallback hover color for /p cta button
    );
  }, []);

  return { ctaColor, chatColor, hoverColor };
};
